<template>
  <div>
    <a-table bordered
            :loading="loading"
            :columns="visibleColumns"
            :data-source="deviceList"
            :pagination="pagination"
            :scroll="{ x: tableScrollX }"
            @change="handleTableChange"
            >
      <template slot="state" slot-scope="state">
        <a-tag v-if="state==1" color="green" style="width: 50px;height: 30px;line-height: 30px;text-align: center;font-size: 12px">开启中</a-tag>
        <a-tag v-else style="width: 50px;height: 30px;line-height: 30px;text-align: center;font-size: 12px">关闭中</a-tag>
      </template>
      <template slot="statusValid" slot-scope="statusValid">
        <a-tag v-if="statusValid==1" color="green">有效</a-tag>
        <a-tag v-else color="red">已过期</a-tag>
      </template>
      <template slot="operation" slot-scope="text, record">
        <span v-if="hasPerm('/deviceuser/activate/') && record.statusValid==1" style="color: #999; margin-right: 8px;">已激活</span>
        <a href="javascript:;" v-else-if="hasPerm('/deviceuser/activate/')" style="color: #33CCE0; margin-right: 8px;" @click="activateDevice(record)">激活</a>
        <a href="javascript:;" v-if="hasPerm('/deviceuser/deleteDeviceuserById/')" style="color: #E84D11;" @click="delDevice(record)">删除</a>
      </template>
    </a-table>
    
    <!-- 删除弹窗 -->
    <a-modal v-model="DELvisible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <a-spin :spinning="DelSpinning">
        <div class="delDevice">
          <div class="DelTitle">删除</div>
          <img src="~@/assets/image/common/DelHint.png" class="delIcon" alt="" />
          <div class="delHint">是否解除{{ DELdeviceName }}与{{DELdeviceUserName}}关联</div>
          <div class="btn-wrap">
            <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
            <a-button class="confirm" @click="confirm">确定</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>

    <!-- 激活设备授权弹窗 -->
    <a-modal v-model="ACTvisible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <a-spin :spinning="ActSpinning">
        <div class="activateBox">
          <div class="activateTitle">激活设备授权</div>
          <img src="~@/assets/image/common/DelHint.png" class="activateIcon" alt="" />
          <div class="activateHint">是否将 {{ ACTdeviceName }} 重新授权（有效期三个月）？</div>
          <div class="btn-wrap">
            <a-button class="cancel margin-right-15" @click="cancelActivate">取消</a-button>
            <a-button class="confirm" @click="confirmActivate">确定</a-button>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { DeviceList, DelDevice, ActivateDevice } from "api/deviceuser";
import {hasPermission} from 'utils/hasPermission'

const allColumns = [
  {key: 'objectid', title: "设备id", align: "center", dataIndex: 'objectid', width: 80, perm: '/deviceuser/column/objectid'},
  {key: 'vptNum', title: "设备编码", align: "center", dataIndex: 'vptNum', ellipsis: true, perm: '/deviceuser/column/vptNum'},
  {key: 'name', title: "IMEI", align: "center", dataIndex: 'name', ellipsis: true, perm: '/deviceuser/column/name'},
  {key: 'deviceNum', title: "出厂编码", align: "center", dataIndex: 'deviceNum', width: 120, perm: '/deviceuser/column/deviceNum'},
  {key: 'vptCode', title: "站点编码", align: "center", dataIndex: 'vptCode', width: 180, perm: '/deviceuser/column/vptCode'},
  {key: 'nickname', title: "昵称", align: "center", dataIndex: 'nickname', ellipsis: true, perm: '/deviceuser/column/nickname'},
  {key: 'userName', title: "微信昵称", align: "center", dataIndex: 'userName', ellipsis: true, perm: '/deviceuser/column/userName'},
  {key: 'uname', title: '账号', align: "center", dataIndex: 'uname', perm: '/deviceuser/column/uname'},
  {key: 'state', title: "设备状态", align: "center", dataIndex: 'state', scopedSlots: { customRender: 'state' }, perm: '/deviceuser/column/state'},
  {key: 'authorizeTime', title: "授权时间", align: "center", dataIndex: 'authorizeTime', ellipsis: true, perm: null},
  {key: 'expireTime', title: "过期时间", align: "center", dataIndex: 'expireTime', ellipsis: true, perm: null},
  {key: 'statusValid', title: "授权状态", align: "center", dataIndex: 'statusValid', scopedSlots: { customRender: 'statusValid' }, perm: null},
  {key: 'operation', title: '操作', align: "center", width: 200, dataIndex: 'operation', scopedSlots: { customRender: 'operation' }, fixed: 'right', perm: null}
];

export default {
  name: 'DeviceuserTable',
  data() {
    return {
      allColumns,
      pagination: {
				defaultPageSize: 10,
        showQuickJumper: true,
        total: 0,
        showTotal: total => `共 ${this.pagination.total} 条数据`,
        onShowSizeChange: (current, pageSize) => this.pageSize = pageSize
      },

      loading: false,
      DelSpinning: false,

      pageIndex: 0,
	    pageSize: 10,
      deviceName: "",
      userName:"",

      deviceList: [],

      DELvisible: false,
      DELdeviceName: "",
      DELdeviceUserName:"",
      DELdeviceId: Number,

      ACTvisible: false,
      ActSpinning: false,
      ACTdeviceName: "",
      ACTdeviceId: Number
    };
  },
  computed: {
    visibleColumns() {
      return allColumns.filter(col => !col.perm || hasPermission(col.perm));
    },
    tableScrollX() {
      const totalWidth = this.visibleColumns.reduce((sum, col) => {
        return sum + (Number(col.width) || 160);
      }, 0);
      return Math.max(totalWidth, 1200);
    }
  },
  mounted() {
    this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName, this.userName);
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      console.log("pagination------------",pagination)
      pager.current = pagination.current;
      this.pagination = pager;
      this.pageIndex = pagination.current
      this.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName, this.userName)
    },
    onSearch() {
      this.pageIndex = 0;
      this.pagination.current = 1;
      this.getDeviceListData(0, this.pageSize, this.deviceName, this.userName)
    },
    delDevice(record) {
      this.DELvisible = !this.DELvisible;
      this.DELdeviceName = record.name;
      this.DELdeviceUserName = record.userName;
      this.DELdeviceId = record.id;
    },
    activateDevice(record) {
      if (record.statusValid == 1) {
        this.$message.info('当前设备授权仍在有效期内');
        return;
      }
      this.ACTvisible = true;
      this.ACTdeviceName = record.name;
      this.ACTdeviceId = record.id;
    },
    cancelActivate() {
      this.ACTvisible = false;
    },
    confirmActivate() {
      let that = this;
      that.ActSpinning = true;
      ActivateDevice(that.ACTdeviceId)
        .then(res => {
          that.$message.success(res.message || '激活成功');
          that.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName, this.userName);
          that.ActSpinning = false;
          that.ACTvisible = false;
        })
        .catch(err => {
          that.ActSpinning = false;
          that.ACTvisible = false;
          that.$message.error(err.message || '激活失败');
        })
    },
    cancel() {
      this.DELvisible = !this.DELvisible;
    },
    getDeviceListData(pageIndex, pageSize, deviceName,userName) {
      console.log("getDeviceListData==========",pageIndex, pageSize, deviceName,userName)
      this.loading = true;
      DeviceList(pageIndex, pageSize, deviceName,userName)
        .then(res => {
          console.log(res.data);
          this.pagination.total = res.data.total || 0;
          this.deviceList = res.data.rows || [];
          this.loading = false;
          this.pageIndex = pageIndex;
          this.pagination.current = pageIndex;
        })
        .catch(err => {
          this.loading = false;
          console.log(err);
        })
    },
    confirm() {
      let that = this
      that.DelSpinning = true
      DelDevice(this.DELdeviceId)
        .then(res => {
          console.log(res);
          that.$message.success(res.message);
          that.getDeviceListData(this.pageIndex, this.pageSize, this.deviceName);
          that.DelSpinning = false;
          that.DELvisible = false;
        })
        .catch(err => {
          console.log(err);
          that.DelSpinning = false;
          that.DELvisible = false;
          that.$message.error(err.message);
        })
    },
    getDeviceInfo(id) {
      this.infoSpinning = true;
      DeviceInfo(id)
        .then(res => {
          this.infoSpinning = false;
          console.log(res);
          const data = res.data;
          this.deviceInfo = data
        })
        .catch(err => {
          this.infoSpinning = false;
          console.log(err);
        })
    },
    setEditDevice(objectid,vptNum,name,pos,state,cmd,cmdDate) {
    },
    IntToFloat(fee) {
      return parseFloat(fee).toFixed(2);
    },
  }
}
</script>

<style lang='scss' scoped>
::v-deep .ant-table {
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

::v-deep .ant-table-container,
::v-deep .ant-table-content,
::v-deep .ant-table-body,
::v-deep .ant-table-placeholder {
  background: #fff !important;
}

::v-deep .ant-table-thead > tr > th {
  background: #33CCE0 !important;
  color: #fff !important;
  font-weight: 600;
  border-color: #7fddec !important;
}

::v-deep .ant-table-tbody > tr > td {
  background: #fff !important;
}

::v-deep .ant-table-tbody > tr:hover > td {
  background: #e6f9fc !important;
}

::v-deep .ant-table-tbody > tr.ant-table-row-selected > td {
  background: #ccf3f8 !important;
}

::v-deep .ant-table-bordered .ant-table-body > table,
::v-deep .ant-table-bordered .ant-table-fixed-left table,
::v-deep .ant-table-bordered .ant-table-fixed-right table {
  border-color: #7fddec !important;
}

::v-deep .ant-table-bordered .ant-table-thead > tr > th,
::v-deep .ant-table-bordered .ant-table-tbody > tr > td {
  border-color: #b3eaf3 !important;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active {
  border-color: #33CCE0;
}

::v-deep .ant-table-pagination.ant-pagination .ant-pagination-item-active a {
  color: #33CCE0;
}

::v-deep .ant-pagination-prev:hover .ant-pagination-item-link,
::v-deep .ant-pagination-next:hover .ant-pagination-item-link {
  color: #33CCE0;
  border-color: #33CCE0;
}

.delDevice {
  text-align: center;
  .DelTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .delIcon {
    display: inline-block;
    width: 196px;
    height: 160px;
  }
  .delHint {
    color: #212121;
    font-size: 24px;
    line-height: 90px;
  }
  .btn-wrap {
    text-align: center;
    .confirm {
      color: #fff;
      background-color: #33CCE0;
    }
  }
}
.activateBox {
  text-align: center;
  .activateTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .activateIcon {
    display: inline-block;
    width: 196px;
    height: 160px;
  }
  .activateHint {
    color: #212121;
    font-size: 22px;
    line-height: 70px;
  }
  .btn-wrap {
    text-align: center;
    .confirm {
      color: #fff;
      background-color: #33CCE0;
    }
  }
}
.deviceInfo-title {
  line-height: 45px;
  font-size: 28px;
  text-align: center;
  margin-bottom: 15px;
}
.deviceInfo-btn-wrap {
  text-align: center;
  margin-top: 15px;
  .btn-active {
    background-color: #33CCE0;
    color: #fff;
  }
}
</style>
